import { EServiceId } from '../../../../../../../../../../../types/reducers/publishTerms';
import { IExperiments } from '../../../../../../../../../../../types/reducers/experiments';
import { TExperiments } from '../../../../../../../../../../../constants/experiments';
import { getTopTexts } from './getTopTexts';
import { getPremiumTexts } from './getPremiumTexts';
import { getStandardTexts } from './getStandardTexts';

export interface IGetTexts {
  title: string;
  subtitle: string;
  description: string[];
}

export const getServiceText = (
  serviceId: EServiceId,
  experiments: IExperiments,
  allExperiments: TExperiments,
): IGetTexts => {
  switch (serviceId) {
    case EServiceId.top:
      return getTopTexts(experiments, allExperiments);

    case EServiceId.premium:
      return getPremiumTexts(experiments, allExperiments);

    case EServiceId.paid:
      return getStandardTexts(experiments, allExperiments);

    case EServiceId.free:
      return getStandardTexts(experiments, allExperiments);

    default:
      throw new Error(`Service type ${serviceId} is not supported`);
  }
};
